<template>
	<div id="app" class="h-full" :class="vueAppClasses">
		<component :is="$store.getters.getLayout" @setAppClasses="setAppClasses"
				   :key="$store.getters.getLayout"></component>
		<transition name="fade-bottom">
			<Chat v-if="$store.state.chat.display"></Chat>
		</transition>
		<transition name="fade-bottom">
			<ChatAuthor v-if="$store.state.chatAuthor.displayAuthor"></ChatAuthor>
		</transition>
	</div>
</template>

<script>
import themeConfig from '@/../themeConfig.js';
import Client from '@/layouts/Client';
import Author from '@/layouts/Author';
import Manager from '@/layouts/Manager';
import Admin from '@/layouts/Admin';
import Partner from '@/layouts/Partner';
import Chat from '@/components/Chat/Index.vue';
import ChatAuthor from '@/components/ChatAuthor/IndexAuthor.vue';
import notifier from "@/mixins/notifier";

export default {
	mixins: [notifier],
	data() {
		return {
			vueAppClasses: []
		}
	},
	components: {
		Client,
		Author,
		Admin,
		Chat,
		ChatAuthor,
		Manager,
		Partner,
	},
	watch: {
		'$vs.rtl'(val) {
			document.documentElement.setAttribute('dir', val ? 'rtl' : 'ltr')
		}
	},
	methods: {
		toggleClassInBody(className) {
			if (className === 'dark') {
				if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark')
				document.body.classList.add('theme-dark')
			} else if (className === 'semi-dark') {
				if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark')
				document.body.classList.add('theme-semi-dark')
			} else {
				if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark')
				if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark')
			}
		},
		setAppClasses(classesStr) {
			this.vueAppClasses.push(classesStr)
		},
		handleWindowResize() {
			this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)

			// Set --vh property
			document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`)
		},
		handleScroll() {
			this.$store.commit('UPDATE_WINDOW_SCROLL_Y', window.scrollY)
		},
		getColorFromHEX(num) {
			return num.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i
				, (m, r, g, b) => '#' + r + r + g + g + b + b)
				.substring(1).match(/.{2}/g)
				.map(x => parseInt(x, 16))
				.join(", ");
		},
		getColorFromRGB(num) {
			const startStr = "rgb(";
			const endStr = ")";
			const start = num.indexOf(startStr) + + startStr.length;
			const end = num.lastIndexOf(endStr);

			return num.substr(start, end - start);
		},
		changeColors(colors) {
			if (colors === undefined) return;

			const main = colors.theme_color_main;
			const secondary = colors.theme_color_secondary;
			let convertedMain = [];
			let convertedSecondary = [];

			if(main.indexOf("#") === 0) {
				convertedMain = this.getColorFromHEX(main);
			} else {
				convertedMain = this.getColorFromRGB(main);
			}

			if(secondary.indexOf("#") === 0) {
				convertedSecondary = this.getColorFromHEX(secondary);
			} else {
				convertedSecondary = this.getColorFromRGB(secondary);
			}

			this.$vs.theme({
				primary: convertedSecondary,
				main: convertedMain
			});
		},
		updateColorsData() {
			this.changeColors(this.$store.state.website.colors);
		},
		async updateWebsiteInfoInfo () {
			try {
				await this.$store.dispatch("updateWebsiteInfo");

			} catch(e) {
				this.notifyError(e.message);
			}
		},
		async updateWebsiteInfo() {
			try {
				await this.$store.dispatch("updateWebsiteInfo");

			} catch(e) {
				this.notifyError(e.message);
			}
		}
	},
	async mounted() {
		if(this.$store.getters.isClientUrl) {
			await this.updateWebsiteInfoInfo();
			this.updateColorsData();
		}

		this.toggleClassInBody(themeConfig.theme)
		this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)

		const vh = window.innerHeight * 0.01
		// Then we set the value in the --vh custom property to the root of the document
		document.documentElement.style.setProperty('--vh', `${vh}px`);
	},
	async created() {
		const dir = this.$vs.rtl ? 'rtl' : 'ltr'
		document.documentElement.setAttribute('dir', dir)

		window.addEventListener('resize', this.handleWindowResize)
		window.addEventListener('scroll', this.handleScroll)
	},
	destroyed() {
		window.removeEventListener('resize', this.handleWindowResize)
		window.removeEventListener('scroll', this.handleScroll)
	}
}

</script>
<style lang="scss">
@import "../src/assets/scss/vuexy/functions.scss";

#app {
	h1 {
		font-size: rem(18px);
		color: #626262;
		font-weight: 700;

	}

	.d-flex {
		display: flex;
	}

	.column {
		flex-direction: column;
	}

	.flex-end {
		justify-content: flex-end;
	}
}
</style>
